import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from "react-router-dom";
import { httpRequest } from '../../../helpers/httpService';

import appConfig from '../../../config/env';
import InputText from '../../elements/InputText';
import RenderErrors from '../../elements/RenderErrors';
import Swal from 'sweetalert2';
import Loader from '../../parts/Loader';
 
function AccountProcess ({request_type}){
    let { token } = useParams();
    const [errors, setErrors] = useState([]);
    const [token_status, setTokenStatus] = useState('');
    const [loading, setLoading] = useState(0);
    
    const default_data = {
        password: '',
        password_confirmation: '',
        token: '',
        email: ''
    }
    const [login_data, setLogin] = useState(default_data);
   
    useEffect(() => {
        // Account activation & Reset Password
        if(request_type != 'recover-password'){
            validateToken()
        }
    }, []);

    function inputChange(e) {
        let { value, name } = e.target;

        if (e.target.type === "checkbox") {
            if (e.target.checked) {
                value = 1;
            } else {
                value = 0;
            }
        }

        let new_state = { [name]: value }
        setLogin({ ...login_data, ...new_state });
    }

    function removeErrors(e){
        let { name } = e.target;
        let newErrors = {...errors}

        delete newErrors[name];

        setErrors(newErrors);
    }

    function clearInputs(){
        setLogin(default_data)
    }

    function validateToken(){
        const url = appConfig.apiUrl + '/account/verify-token/' + token;

        setLoading(1)

        httpRequest(url, "GET", {
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((res) => {
            setLoading(0)

            if(res.status == 'valid'){
                setTokenStatus('valid')

                let new_state = { ['token']: token }

                setLogin({ ...login_data, ...new_state });
            }
            else{
                setTokenStatus('invalid')
            }
        })
        .catch((err) => {
            setLoading(0)

            setTokenStatus('invalid')
        });
    }

    function handleSubmit(e){
        e.preventDefault()
        let url = appConfig.apiUrl;
        
        let form_data = { ...login_data }

        if(request_type == 'activation'){
            url += '/account/activate';
            delete form_data.email;
        }
        else if(request_type == 'reset-password'){
            url += '/account/reset-password';
            delete form_data.email;
        }
        else if(request_type == 'recover-password'){
            url += '/account/recover';
            form_data = { email: login_data.email }
        }

        setLoading(1)

        httpRequest(url, "POST", {
            postdata: { 
                ...form_data, 
            },
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((res) => {
            setLoading(0)

            Swal.fire({
                title: "Success!",
                text: res.message,
                icon: "success",
                confirmButtonText: "OK",
                allowOutsideClick: false
            }).then((result) => {
                if (result.isConfirmed) {
                    if(request_type == 'recover-password'){
                        clearInputs()
                    }else{
                        window.location.href = "/login";
                    }
                }
            })

        })
        .catch((err) => {
            setLoading(0)

            if(err.data){
                setErrors( err.data );
                err.message = "Please check your entry";
    
                if(err.data.token){
                    err.message = err.data.token[0];
                }
            }
    
            Swal.fire({
                title: 'Error!',
                text: err.message,
                icon: 'error',
                confirmButtonText: 'OK'
            });
        });
    }

    // const displayForm = ({status = 'fetching'}) => {
    function displayForm(form_type = '', status = ''){
        
        //Recover password form
        if(form_type == 'recover-password'){
            return <section className="faith" style={{minHeight: '700px'}}>
                        <div className="container" style={{position: 'relative'}}>
                            <Loader isLoading={loading}/>
                            <div className="parent">
                                <div className="co-parent">
                                    <div className="container card pb-4 mx-0 px-0 login-container">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <form action="/" method="post">

                                                    <h3 className="faith-login-title mt-3 px-3 mb-3">Recover Password</h3>

                                                    <div className="container">
                                                        <div className='mb-3'>
                                                            <InputText
                                                                id={'email'} 
                                                                name={'email'} 
                                                                value={login_data.email}    
                                                                label='Email Address'
                                                                tagClass="form-control"
                                                                onChange={inputChange}
                                                                onFocus={removeErrors}
                                                                placeholder='Enter your email'
                                                            />
                                                            <RenderErrors 
                                                                errors={errors} 
                                                                name="email" 
                                                                className="text-danger fs-7"
                                                            />
                                                        </div>

                                                        <button type="submit" className="login-button" onClick={handleSubmit}>Continue</button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

        }

        // Account activation & Reset Password Form
        if(status == 'valid'){
            return <section className="faith">
                        <div className="container" style={{position: 'relative'}}>
                            <Loader isLoading={loading}/>
                            <div className="parent">
                                <div className="co-parent">
                                    <div className="container card pb-4 mx-0 px-0 login-container">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <form action="/" method="post">

                                                    <h3 className="faith-login-title mt-3 px-3 mb-3">{request_type == 'activation' ? "Account Activation" : "Reset Password"}</h3>

                                                    <div className="container">
                                                        <div className='mb-3'>
                                                                <InputText
                                                                    id={'password'} 
                                                                    name={'password'}
                                                                    value={login_data.password} 
                                                                    label={request_type == 'activation' ? "Password" : "New Password"}
                                                                    tagClass="form-control"
                                                                    type='password'
                                                                    onChange={inputChange}
                                                                    onFocus={removeErrors}
                                                                    placeholder='Enter your password'
                                                                />
                                                                <RenderErrors 
                                                                    errors={errors} 
                                                                    name="password" 
                                                                    className="text-danger fs-7"
                                                                />
                                                        </div>

                                                        <div className='mb-3'>
                                                            <InputText
                                                                id={'password_confirmation'} 
                                                                name={'password_confirmation'}
                                                                value={login_data.password_confirmation} 
                                                                label={request_type == 'activation' ? "Confirm Password" : "Confirm New Password"}
                                                                tagClass="form-control"
                                                                type='password'
                                                                onChange={inputChange}
                                                                onFocus={removeErrors}
                                                                placeholder='Enter confirm password'
                                                            />
                                                            <RenderErrors 
                                                                errors={errors} 
                                                                name="password_confirmation" 
                                                                className="text-danger fs-7"
                                                            />
                                                        </div>

                                                        <button type="submit" className="login-button" onClick={handleSubmit}>Continue</button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
        }
        else if(status == 'invalid'){
            return <section className="faith h-100">
                        <div className="container">
                            <div className="parent" style={{width: '100%', minHeight: '700px'}}>
                                <div className="container d-flex flex-column justify-content-center align-items-center">
                                    <h1 className="success-title text-center">Oopps. Invalid Token!</h1>
                                    <p className="success-text mb-5 text-center">Request token either expired or invalid.</p>
                                    <Link to='/' className="btn btn-return py-3">Return to Home Page</Link>
                                </div>
                            </div>
                        </div>
                    </section>
        }
        
        return <section className="faith h-100">
                            <div className="container">
                                <div className="parent" style={{width: '100%', minHeight: '700px'}}>
                                    <div className="container d-flex flex-column justify-content-center align-items-center">
                                        <h1 className="success-title text-center">Validating token. Please Wait...</h1>
                                    </div>
                                </div>
                            </div>
                        </section>
        
    };

    return (
        displayForm(request_type, token_status)
    )
}
 
export default AccountProcess;